module.exports = __webpack_public_path__ + "static/media/rocket-launch.a1b548b1.svg";